import BlockSeerSearch from "@/components/wallet-search";
import { BitcoinPriceCard } from "@/components/dashboard/bitcoin-price-card";
import { NetworkHashRateCard } from "@/components/dashboard/network-hash-rate-card";
import { LatestBlocksTable } from "@/components/dashboard/latest-blocks-table";
import { LatestTransactionsTable } from "@/components/dashboard/latest-transactions-table";

export default function SearchLandingPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <div className="flex flex-col flex-grow min-h-screen">
        <div className="flex-grow flex justify-center pb-2 px-4 sm:px-6 lg:px-8 bg-background">
          <div className="w-full max-w-7xl">
            <BlockSeerSearch />
            
            {/* Dashboard Section */}
            <div className="mt-8 space-y-6">
              {/* Metrics Cards */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <BitcoinPriceCard />
                <NetworkHashRateCard />
              </div>
              
              {/* Tables */}
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <LatestBlocksTable />
                <LatestTransactionsTable />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 